const onDev = false;

exports.conf = {
  onDev,
  organization: {
    name: "อุตสาหกรรมเกษตร",
    sub_name: "มหาวิทยาลัยเชียงใหม่",
  },
  app_id: "10",
  loginCallback:
    onDev === true
      ? "http://localhost:3000/epayment/login"
      : "https://epayment.agro.cmu.ac.th/epayment/login",
  endpoint: {
    // epayment: "http://localhost:3001/epayment",
    // paidCallback: "http://localhost:3033/epayment/v3/paid",
    epayment: "https://pay.agro.cmu.ac.th/epayment",
    paidCallback: "https://pay.agro.cmu.ac.th/epayment/v3/paid",

    // auth: "https://apis-3003.lib.cmu.ac.th/platform/oauth",
    auth: "https://cloud-3001.lib.cmu.ac.th/passport",
  },
  key: {
    auth: "jxnGUfgfywIdSIOiKI0qPIrvtkQObJOl",
  },
  cookieName: "cmul-epayment-cookie",
  cookiePrint: "cmul-epayment-cookie-print",
};
